import { dataHooks } from '@wix/data-hooks';

export const inspirationalTemplateDataHooks = dataHooks<{
  viewButton: { key: string };
  editButton: { key: string };
}>('inspirational-template');
